import {FilterMatchMode, FilterOperator} from "primereact/api";
import {
    IVR_CONFIGURATION_CLEAR_FILTERS,
    SET_IVR_CONFIGURATION_UI_FILTERS,
    GET_IVR_CONFIGURATION,
    GET_IVR_CONFIGURATION_PAGINATION,
    GET_IVR_CONFIGURATIONS,
    INITIAL_IVR_CONFIGURATION_DATA,
    SELECTED_IVR_CONFIGURATION_ID,
    SET_IVR_CONFIGURATION_CURRENT_PAGE,
    SET_IVR_CONFIGURATION_CURRENT_SIZE,
    SET_IVR_CONFIGURATION_ERROR_FIELDS,
    SHOW_IVR_CONFIGURATION_DETAIL_LOADING,
    SHOW_IVR_CONFIGURATION_LOADER,
    IVR_CONFIGURATION_DIALOG_VISIBLE,
    IVR_CONFIGURATION_FIELD,
    SET_IVR_SCHEME_GRAPH_API_SLICE,
} from "../types/typesIVRConfigurationList";

const initialState = {
    ivrConfigurationDialogVisible: false,
    selectedIVRConfigurationId: null,
    clearFilters: {
        flowId: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        name: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
        isActive: {value: null, matchMode: FilterMatchMode.IN},
    },
    ivrConfigurationsList: [],
    pagination: {
        hasNext: false,
        pageNumber: 0,
    },
    paginationPage: 1,
    paginationSize: 10,
    ivrConfigurationData: {
        configuration: {
            flowId: null,
            name: null,
            branchId: null,
            description: null,
            isActive: false,
            entryElementId: null,
        },
        elements: [] as unknown[],
        routes: [] as unknown[],
        schedules: [] as unknown[],
        _ivrSchedulesServerSnapshot: [] as unknown[],
    },
    loading: false,
    detailsLoading: false,
    errorFields: null,
}

export const IVRConfigurationReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case IVR_CONFIGURATION_DIALOG_VISIBLE:
            return {...state, ivrConfigurationDialogVisible: action.payload}
        case SELECTED_IVR_CONFIGURATION_ID:
            return {...state, selectedIVRConfigurationId: action.payload}
        case IVR_CONFIGURATION_FIELD: {
            const cur = state.ivrConfigurationData as Record<string, unknown>;
            const conf = (cur.configuration as Record<string, unknown>) ?? {};
            return {
                ...state,
                ivrConfigurationData: {
                    ...cur,
                    configuration: {
                        ...conf,
                        [action.payload.fieldName]: action.payload.value,
                    },
                },
            };
        }
        case SET_IVR_SCHEME_GRAPH_API_SLICE: {
            const cur = state.ivrConfigurationData as Record<string, unknown>;
            const conf = (cur.configuration as Record<string, unknown>) ?? {};
            const {
                elements,
                routes,
                schedules,
                configurationPatch,
                schedulesServerSnapshotReplace,
            } = action.payload;
            const nextSnapshot =
                schedulesServerSnapshotReplace !== undefined
                    ? [...schedulesServerSnapshotReplace]
                    : (cur._ivrSchedulesServerSnapshot ?? []);
            return {
                ...state,
                ivrConfigurationData: {
                    ...cur,
                    elements,
                    routes,
                    schedules,
                    _ivrSchedulesServerSnapshot: nextSnapshot,
                    configuration: {
                        ...conf,
                        entryElementId:
                            configurationPatch?.entryElementId ??
                            conf.entryElementId ??
                            null,
                    },
                },
            };
        }
        case IVR_CONFIGURATION_CLEAR_FILTERS:
            return {
                ...state, clearFilters: {
                    flowId: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    name: {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]},
                    isActive: {value: null, matchMode: FilterMatchMode.IN},
                }
            }
        case SET_IVR_CONFIGURATION_UI_FILTERS: {
            const nextFilters = { ...state.clearFilters };
            Object.entries(action.payload || {}).forEach(([filterField, filterValue]) => {
                // @ts-ignore
                const existingFilter = nextFilters[filterField];
                if (!existingFilter) return;
                if ('constraints' in existingFilter) {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        constraints: [
                            {
                                ...existingFilter.constraints[0],
                                value: filterValue
                            }
                        ]
                    };
                } else {
                    // @ts-ignore
                    nextFilters[filterField] = {
                        ...existingFilter,
                        value: filterValue
                    };
                }
            });
            return {
                ...state,
                clearFilters: nextFilters
            };
        }
        case GET_IVR_CONFIGURATIONS:
            return {...state, ivrConfigurationsList: action.payload}
        case GET_IVR_CONFIGURATION_PAGINATION:
            return {
                ...state,
                pagination: {
                    hasNext: !!action.payload.hasNext,
                    pageNumber: Number(action.payload.pageNumber) || 0,
                },
            }
        case SET_IVR_CONFIGURATION_CURRENT_PAGE:
            return {...state, paginationPage: action.payload}
        case SET_IVR_CONFIGURATION_CURRENT_SIZE:
            return {...state, paginationSize: action.payload}
        case GET_IVR_CONFIGURATION: {
            const p = action.payload;
            if (
                p == null ||
                Array.isArray(p) ||
                typeof p !== "object" ||
                !("configuration" in p) ||
                (p as { configuration?: unknown }).configuration == null ||
                typeof (p as { configuration?: unknown }).configuration !== "object"
            ) {
                return state;
            }
            return {
                ...state,
                ivrConfigurationData: {
                    ...(p as Record<string, unknown>),
                    _ivrSchedulesServerSnapshot: Array.isArray(
                        (p as { schedules?: unknown }).schedules
                    )
                        ? [...(p as { schedules: unknown[] }).schedules]
                        : [],
                } as any,
            };
        }
        case SHOW_IVR_CONFIGURATION_LOADER:
            return {...state, loading: action.payload}
        case SHOW_IVR_CONFIGURATION_DETAIL_LOADING:
            return {...state, detailsLoading: action.payload}
        case INITIAL_IVR_CONFIGURATION_DATA:
            return {...state, ivrConfigurationData: initialState.ivrConfigurationData}
        case SET_IVR_CONFIGURATION_ERROR_FIELDS:
            return {...state, errorFields: action.payload}
        default:
            return state
    }
}

